module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_m_leucistic.7919d94e.png";